
export const environment = {
  production: true,
  apiEndpoint: './chubb',
  authorizationPrefix: 'Bearer ',
  ssoAuthorizationPrefix: 'Bearers ',
  localStorageName: 'agentQniLs',
  isShowLog: false,
  version: '2.3.32',
  translateUrl: './chubb/translate/lang',
  translateSuffix: '',
  localeUrl: './chubb/translate/locale',
  path: {
    login: '/login',
    home: '/home'
  },
  /* Set isSso to default login by SSO. It will redirect to Single Sign-On page automatically */
  isSso: true,
  ssoLoginUrl:'https://auth.chubb.com/auth.chubb.com/B2C_1A_CHUBBLIFE_TH_SIGNIN/oauth2/v2.0/authorize',
  redirectPath:'redirect_uri=https://esmart.chubblife-agency.in.th/chubb-life-qni/chubb/auth/redirectToQni',
  responseType:'response_type=code',
  clientId:'client_id=347f2440-32d5-4d6b-b6e6-7cf7e1a7ff79',
  //scope:'scope=openid%20https://b2c.chubbdigital.com/ChubbLifeAPI-TH/Read',
  scope:'scope=openid%20https://b2c.chubbdigital.com/ChubbLifeAPI-TH/read%20https://b2c.chubbdigital.com/ChubbLifeAPI-TH/write%20https://b2c.chubbdigital.com/ChubbLifeAPI-TH/access.operations.allow%20offline_access',
  logoutUrl:'https://sso.acegroup.com/idp/startSLO.ping?',
  targetResource:'TargetResource=https://esmart.chubblife-agency.in.th/chubb-life-qni/index.html',
  redirectEpos:'https://eapp.chubblife-agency.in.th/agent/login/sso?callback=/',
  urlDestination:'https://esmart.chubblife-agency.in.th/chubb-life-qni/',
  sessionTimeoutWarningMin: 15,
  IdleTimeoutCountdownMin: 45,
  IdleTimeoutWarningMin: 15,
    newsPopup: {
    effectiveDate: '2025-11-26',
    expiryDate: '2026-12-31',
    popupId: 'news_2025_11_v1',
    style: 'navigation',
    leftButtonUrl: 'https://esales.cl-agency.in.th',
    leftButtonText: 'news_popup.left_button',
    rightButtonText: 'news_popup.right_button'
  },
  announcement: {
    enabled: true,
    message: 'announcement.message',
    actionText: 'announcement.action',
    actionUrl: 'https://esales.cl-agency.in.th',
    effectiveDate: '2026-01-09',
    expiryDate: '2026-12-31'
  }
};

